import React, { useState, useCallback, useEffect, useRef } from "react";
import { useAPI } from "app/hooks/useApi";
import { useSmartNavigation } from "app/utils/navigationHelper";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import { Formik, Form } from "formik";
import { CLASSES_NICE, searchClassesNice, getClasseResumo } from "app/constants/classes-nice";
import * as XLSX from "xlsx";
import {
  Box,
  Grid,
  Select,
  MenuItem,
  TextField,
  Button,
  FormControl,
  InputLabel,
  FormControlLabel,
  Checkbox,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  TablePagination,
  CircularProgress,
  Alert,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slider,
  FormLabel,
  FormGroup,
  Divider,
  Autocomplete,
  Chip,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Menu,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ImageIcon from "@mui/icons-material/Image";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ViewListIcon from "@mui/icons-material/ViewList";
import TableRowsIcon from "@mui/icons-material/TableRows";
import HeaderPages from "../components/HeaderPages";

const cfeCodesList = [
  {
    value: "01",
    label: "Categoria 01 - Corpos celestes, fenômenos naturais, mapas geográficos",
    category: "general",
    isGeneral: true,
  },
  { value: "02", label: "Categoria 02 - Seres humanos", category: "general", isGeneral: true },
  { value: "03", label: "Categoria 03 - Animais", category: "general", isGeneral: true },
  {
    value: "04",
    label: "Categoria 04 - Seres sobrenaturais, deuses, demônios, seres fantásticos",
    category: "general",
    isGeneral: true,
  },
  { value: "05", label: "Categoria 05 - Plantas", category: "general", isGeneral: true },
  {
    value: "24",
    label: "Categoria 24 - Heráldica, moedas, emblemas, símbolos",
    category: "general",
    isGeneral: true,
  },
  {
    value: "26",
    label: "Categoria 26 - Figuras geométricas",
    category: "general",
    isGeneral: true,
  },
  { value: "27", label: "Categoria 27 - Grafismos", category: "general", isGeneral: true },
  { value: "29", label: "Categoria 29 - Cores", category: "general", isGeneral: true },
  { value: "01.01.01", label: "01.01.01 - Sol", category: "1" },
  { value: "01.01.02", label: "01.01.02 - Lua", category: "1" },
  { value: "01.01.03", label: "01.01.03 - Estrela", category: "1" },
  { value: "01.01.05", label: "01.01.05 - Outros corpos celestes", category: "1" },
  { value: "01.03.01", label: "01.03.01 - Trovão, raio", category: "1" },
  { value: "01.03.02", label: "01.03.02 - Nuvens", category: "1" },
  { value: "01.03.03", label: "01.03.03 - Chuva", category: "1" },
  { value: "01.03.04", label: "01.03.04 - Neve", category: "1" },
  { value: "01.03.05", label: "01.03.05 - Vento", category: "1" },
  { value: "01.15.01", label: "01.15.01 - Mapas geográficos", category: "1" },
  { value: "02.01.01", label: "02.01.01 - Homens", category: "2" },
  { value: "02.01.02", label: "02.01.02 - Mulheres", category: "2" },
  { value: "02.01.03", label: "02.01.03 - Crianças", category: "2" },
  { value: "02.01.30", label: "02.01.30 - Família, grupos", category: "2" },
  { value: "02.03.01", label: "02.03.01 - Cabeça, face", category: "2" },
  { value: "02.03.04", label: "02.03.04 - Olhos", category: "2" },
  { value: "02.03.05", label: "02.03.05 - Nariz", category: "2" },
  { value: "02.03.06", label: "02.03.06 - Boca, lábios, língua", category: "2" },
  { value: "02.03.07", label: "02.03.07 - Dentes", category: "2" },
  { value: "02.05.01", label: "02.05.01 - Mãos, braços", category: "2" },
  { value: "02.07.01", label: "02.07.01 - Pés, pernas", category: "2" },
  { value: "03.01.01", label: "03.01.01 - Quadrúpedes (série I)", category: "3" },
  { value: "03.01.08", label: "03.01.08 - Cães", category: "3" },
  { value: "03.01.09", label: "03.01.09 - Gatos", category: "3" },
  { value: "03.01.11", label: "03.01.11 - Bovinos", category: "3" },
  { value: "03.01.12", label: "03.01.12 - Cavalos", category: "3" },
  { value: "03.01.14", label: "03.01.14 - Ovelhas, cordeiros", category: "3" },
  { value: "03.01.16", label: "03.01.16 - Porcos", category: "3" },
  { value: "03.01.17", label: "03.01.17 - Felinos grandes", category: "3" },
  { value: "03.04.01", label: "03.04.01 - Aves (série I)", category: "3" },
  { value: "03.04.07", label: "03.04.07 - Galos, galinhas", category: "3" },
  { value: "03.04.11", label: "03.04.11 - Águias", category: "3" },
  { value: "03.04.24", label: "03.04.24 - Pombos", category: "3" },
  { value: "03.07.01", label: "03.07.01 - Peixes", category: "3" },
  { value: "03.19.01", label: "03.19.01 - Insetos, aranhas", category: "3" },
  { value: "03.19.07", label: "03.19.07 - Abelhas", category: "3" },
  { value: "03.19.11", label: "03.19.11 - Borboletas", category: "3" },
  { value: "04.01.01", label: "04.01.01 - Anjos", category: "4" },
  { value: "04.02.01", label: "04.02.01 - Demônios, diabos", category: "4" },
  { value: "04.05.01", label: "04.05.01 - Seres fantásticos", category: "4" },
  { value: "04.05.05", label: "04.05.05 - Dragões", category: "4" },
  { value: "05.01.01", label: "05.01.01 - Árvores, arbustos", category: "5" },
  { value: "05.01.05", label: "05.01.05 - Árvores coníferas", category: "5" },
  { value: "05.01.11", label: "05.01.11 - Palmeiras", category: "5" },
  { value: "05.03.01", label: "05.03.01 - Folhas", category: "5" },
  { value: "05.03.11", label: "05.03.11 - Folhas estilizadas", category: "5" },
  { value: "05.05.01", label: "05.05.01 - Flores", category: "5" },
  { value: "05.05.20", label: "05.05.20 - Rosas", category: "5" },
  { value: "05.07.01", label: "05.07.01 - Cereais", category: "5" },
  { value: "05.09.01", label: "05.09.01 - Frutas", category: "5" },
  { value: "05.11.01", label: "05.11.01 - Legumes", category: "5" },
  { value: "24.01.01", label: "24.01.01 - Escudos", category: "24" },
  { value: "24.01.05", label: "24.01.05 - Coroas", category: "24" },
  { value: "24.01.15", label: "24.01.15 - Bandeiras", category: "24" },
  { value: "24.01.17", label: "24.01.17 - Símbolos postais", category: "24" },
  { value: "24.09.01", label: "24.09.01 - Cruzes", category: "24" },
  { value: "24.11.01", label: "24.11.01 - Símbolos religiosos", category: "24" },
  { value: "24.13.01", label: "24.13.01 - Símbolos musicais", category: "24" },
  { value: "24.15.01", label: "24.15.01 - Símbolos matemáticos", category: "24" },
  { value: "24.17.01", label: "24.17.01 - Setas", category: "24" },
  { value: "26.01.01", label: "26.01.01 - Círculos", category: "26" },
  { value: "26.01.03", label: "26.01.03 - Um círculo", category: "26" },
  { value: "26.01.04", label: "26.01.04 - Vários círculos", category: "26" },
  { value: "26.01.18", label: "26.01.18 - Círculos com elementos internos", category: "26" },
  { value: "26.03.01", label: "26.03.01 - Triângulos", category: "26" },
  { value: "26.03.03", label: "26.03.03 - Um triângulo", category: "26" },
  { value: "26.03.04", label: "26.03.04 - Vários triângulos", category: "26" },
  { value: "26.04.01", label: "26.04.01 - Quadriláteros", category: "26" },
  { value: "26.04.02", label: "26.04.02 - Retângulos", category: "26" },
  { value: "26.04.03", label: "26.04.03 - Quadrados", category: "26" },
  { value: "26.04.09", label: "26.04.09 - Losangos", category: "26" },
  { value: "26.05.01", label: "26.05.01 - Polígonos", category: "26" },
  { value: "26.05.02", label: "26.05.02 - Pentágonos", category: "26" },
  { value: "26.05.03", label: "26.05.03 - Hexágonos", category: "26" },
  { value: "26.05.04", label: "26.05.04 - Octógonos", category: "26" },
  { value: "26.11.01", label: "26.11.01 - Linhas, faixas", category: "26" },
  { value: "26.11.02", label: "26.11.02 - Linhas retas", category: "26" },
  { value: "26.11.03", label: "26.11.03 - Linhas curvas", category: "26" },
  { value: "26.11.08", label: "26.11.08 - Linhas formando ângulos", category: "26" },
  { value: "26.13.01", label: "26.13.01 - Superfícies ou figuras sombreadas", category: "26" },
  { value: "27.01.01", label: "27.01.01 - Uma letra", category: "27" },
  { value: "27.01.02", label: "27.01.02 - Duas letras", category: "27" },
  { value: "27.01.03", label: "27.01.03 - Três letras", category: "27" },
  { value: "27.01.04", label: "27.01.04 - Quatro letras", category: "27" },
  { value: "27.01.05", label: "27.01.05 - Cinco letras", category: "27" },
  { value: "27.01.06", label: "27.01.06 - Mais de cinco letras", category: "27" },
  { value: "27.03.01", label: "27.03.01 - Algarismos", category: "27" },
  { value: "27.05.01", label: "27.05.01 - Letras apresentando forma especial", category: "27" },
  { value: "27.05.17", label: "27.05.17 - Letras sublinhadas, barradas", category: "27" },
  { value: "27.07.01", label: "27.07.01 - Letras ligadas a elemento figurativo", category: "27" },
  { value: "29.01.01", label: "29.01.01 - Vermelho", category: "29" },
  { value: "29.01.02", label: "29.01.02 - Rosa", category: "29" },
  { value: "29.01.03", label: "29.01.03 - Laranja", category: "29" },
  { value: "29.01.04", label: "29.01.04 - Amarelo", category: "29" },
  { value: "29.01.05", label: "29.01.05 - Verde", category: "29" },
  { value: "29.01.06", label: "29.01.06 - Azul", category: "29" },
  { value: "29.01.07", label: "29.01.07 - Violeta", category: "29" },
  { value: "29.01.08", label: "29.01.08 - Marrom", category: "29" },
  { value: "29.01.11", label: "29.01.11 - Cinza", category: "29" },
  { value: "29.01.12", label: "29.01.12 - Preto", category: "29" },
  { value: "29.01.13", label: "29.01.13 - Branco", category: "29" },
];

function WebseekPage() {
  const { makeRequest } = useAPI();
  const { navigateToProcesso } = useSmartNavigation();

  const initialValues = {
    nclFields: [{ value: "", logic: "ou" }],
    afinidade: "Não",
    fonetica: "Não",
    palavraFields: [{ value: "", option: "Radical", logic: "ou" }],
    cfeFields: [{ value: "", exato: false, logic: "e" }],
    titular: "",
    orderBy: "numero",
    orderDirection: "desc",
  };

  const [results, setResults] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [searchParams, setSearchParams] = useState({});
  const [error, setError] = useState(null);
  const [nclClasses, setNclClasses] = useState([]);
  const [loadingNcl, setLoadingNcl] = useState(false);

  const [imageSimilarityModal, setImageSimilarityModal] = useState(false);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageSimilarityParams, setImageSimilarityParams] = useState({
    similarityThreshold: 70,
    incluirMesmaCategoria: true,
    incluirMesmoTitular: false,
    excluirMesmoProcesso: true,
    page: 1,
    limit: 20,
  });
  const [imageSimilarityLoading, setImageSimilarityLoading] = useState(false);

  const [selectedCFEs, setSelectedCFEs] = useState([]);
  const [cfeExatoOptions, setCfeExatoOptions] = useState({});

  const [selectedProcesso, setSelectedProcesso] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);
  const [imageViewModalOpen, setImageViewModalOpen] = useState(false);
  const [selectedImageProcesso, setSelectedImageProcesso] = useState(null);
  const [cfeData, setCfeData] = useState(null);
  const [cfeLoading, setCfeLoading] = useState(false);

  const [viewMode, setViewMode] = useState("resumido");
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [exportMenuAnchor, setExportMenuAnchor] = useState(null);
  const [copySuccess, setCopySuccess] = useState(false);

  // ─── CFE helpers ────────────────────────────────────────────────────────────

  const handleCFESelection = (event, newValue) => {
    setSelectedCFEs(newValue);
    const newExatoOptions = { ...cfeExatoOptions };
    newValue.forEach((cfe) => {
      if (!(cfe.value in newExatoOptions)) newExatoOptions[cfe.value] = false;
    });
    Object.keys(newExatoOptions).forEach((cfeValue) => {
      if (!newValue.some((cfe) => cfe.value === cfeValue)) delete newExatoOptions[cfeValue];
    });
    setCfeExatoOptions(newExatoOptions);
  };

  const handleCFEExatoChange = (cfeValue, exato) => {
    setCfeExatoOptions((prev) => ({ ...prev, [cfeValue]: exato }));
  };

  // ─── Dynamic field helpers ───────────────────────────────────────────────────

  const addNclField = (setFieldValue, values) =>
    setFieldValue("nclFields", [...values.nclFields, { value: "", logic: "ou" }]);

  const removeNclField = (setFieldValue, values, index) =>
    setFieldValue(
      "nclFields",
      values.nclFields.filter((_, i) => i !== index)
    );

  const addPalavraField = (setFieldValue, values) =>
    setFieldValue("palavraFields", [
      ...values.palavraFields,
      { value: "", option: "Radical", logic: "ou" },
    ]);

  const removePalavraField = (setFieldValue, values, index) =>
    setFieldValue(
      "palavraFields",
      values.palavraFields.filter((_, i) => i !== index)
    );

  const addCfeField = (setFieldValue, values) =>
    setFieldValue("cfeFields", [...values.cfeFields, { value: "", exato: false, logic: "e" }]);

  const removeCfeField = (setFieldValue, values, index) =>
    setFieldValue(
      "cfeFields",
      values.cfeFields.filter((_, i) => i !== index)
    );

  // ─── Validation ─────────────────────────────────────────────────────────────

  const hasValidSearchParams = (params) => {
    if (params.nclFields?.some((f) => f.value && f.value !== "" && f.value !== null)) return true;
    if (params.palavraFields?.some((f) => f.value && f.value.trim() !== "")) return true;
    if (params.cfeFields?.some((f) => f.value && f.value.trim() !== "")) return true;
    if (params.titular && params.titular.trim() !== "") return true;
    return false;
  };

  // ─── Build API params (shared between search and export) ────────────────────

  const buildApiParams = (params, currentPage = 0, limit = 30) => {
    const apiParams = { page: currentPage + 1, limit };

    // NCL
    const validNclFields = (params.nclFields || []).filter(
      (f) => f.value && f.value !== "" && f.value !== null
    );
    if (validNclFields.length > 0) {
      apiParams.nclFields = validNclFields.map((f) => ({
        value: f.value.toString().trim(),
        logic: f.logic || "ou",
      }));
    }

    apiParams.afinidade = params.afinidade === "Sim";
    apiParams.fonetica = params.fonetica === "Sim";

    // Palavra
    const validPalavraFields = (params.palavraFields || []).filter(
      (f) => f.value && f.value.trim() !== ""
    );
    if (validPalavraFields.length > 0) {
      apiParams.palavraFields = validPalavraFields.map((f) => ({
        value: f.value.trim(),
        option: f.option || "Radical",
        logic: f.logic || "ou",
      }));
    }

    // CFE
    const validCfeFields = (params.cfeFields || []).filter((f) => f.value && f.value.trim() !== "");
    if (validCfeFields.length > 0) {
      apiParams.cfeFields = validCfeFields.map((f) => ({
        value: f.value.trim(),
        exato: Boolean(f.exato),
        logic: f.logic || "e",
      }));
    }

    // Titular (NEW)
    if (params.titular && params.titular.trim() !== "") {
      apiParams.titular = params.titular.trim();
    }

    if (params.orderBy) apiParams.orderBy = params.orderBy;
    if (params.orderDirection) apiParams.orderDirection = params.orderDirection;

    return apiParams;
  };

  // ─── Fetch results ───────────────────────────────────────────────────────────

  const fetchResults = async (params, currentPage = 0, limit = 30) => {
    if (loading) return;
    if (!hasValidSearchParams(params)) {
      setError("Por favor, preencha pelo menos um campo de busca (NCL, Palavra, CFE ou Titular).");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const apiParams = buildApiParams(params, currentPage, limit);
      const response = await makeRequest("/webseek/search", "POST", apiParams, {});

      if (response && (response.status === 200 || response.status === 201)) {
        if (response.data && Array.isArray(response.data.data)) {
          setResults(response.data.data);
          setCount(response.data.pagination?.total || response.data.data.length);
        } else if (response.data && Array.isArray(response.data.items)) {
          setResults(response.data.items);
          setCount(response.data.total || response.data.items.length);
        } else if (response.data && Array.isArray(response.data)) {
          setResults(response.data);
          setCount(response.data.length);
        } else {
          setResults([]);
          setCount(0);
          setError("Formato de resposta inválido.");
        }
      } else {
        setResults([]);
        setCount(0);
        setError("Erro na consulta. Status: " + (response ? response.status : "desconhecido"));
      }
    } catch (err) {
      if (err.response) {
        setError(
          `[Webseek] Erro ${err.response.status}: ${
            err.response.data?.message || "Erro desconhecido"
          }`
        );
      } else if (err.request) {
        setError("[Webseek] Sem resposta do servidor. Verifique sua conexão de internet.");
      } else {
        setError(
          "[Webseek] Erro ao configurar a requisição: " + (err.message || "Erro desconhecido")
        );
      }
      setResults([]);
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  // ─── Export to Excel ─────────────────────────────────────────────────────────

  const handleExportExcel = async () => {
    if (!hasValidSearchParams(searchParams)) {
      setError("Realize uma busca antes de exportar.");
      return;
    }

    setExportLoading(true);
    setError(null);

    try {
      // Fetch ALL results (ignore pagination) for export
      const apiParams = buildApiParams(searchParams, 0, count || 10000);
      const response = await makeRequest("/webseek/search", "POST", apiParams, {});

      let allResults = [];
      if (response?.data?.data && Array.isArray(response.data.data)) {
        allResults = response.data.data;
      } else if (response?.data && Array.isArray(response.data)) {
        allResults = response.data;
      }

      if (allResults.length === 0) {
        setError("Nenhum resultado para exportar.");
        return;
      }

      // Build rows for Excel
      const rows = allResults.map((row) => {
        const marcaNome =
          Array.isArray(row?.marca) && row.marca.length > 0
            ? row.marca[0]?.nome ?? ""
            : row?.marca?.nome ?? "";

        const titulares =
          Array.isArray(row?.titulares) && row.titulares.length > 0
            ? row.titulares.map((t) => t.nome_razao_social).join("; ")
            : "---";

        const classesNcl =
          Array.isArray(row?.classes_nice) && row.classes_nice.length > 0
            ? row.classes_nice.map((c) => c.codigo).join("; ")
            : "---";

        return {
          "Nº Processo": row?.numero ?? "---",
          Marca: marcaNome || "---",
          Procurador: row?.procurador ?? "---",
          Titular: titulares,
          Situação: row?.situacao ?? "---",
          Natureza: row?.natureza ?? "---",
          Apresentação: row?.apresentacao ?? "---",
          "Classes NCL": classesNcl,
          "Data Depósito": row?.data_deposito
            ? new Date(row.data_deposito).toLocaleDateString("pt-BR")
            : "---",
          "Data Concessão": row?.data_concessao
            ? new Date(row.data_concessao).toLocaleDateString("pt-BR")
            : "---",
          "Data Vigência": row?.data_vigencia
            ? new Date(row.data_vigencia).toLocaleDateString("pt-BR")
            : "---",
        };
      });

      // Create workbook
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(rows);

      // Column widths
      ws["!cols"] = [
        { wch: 18 }, // Nº Processo
        { wch: 30 }, // Marca
        { wch: 30 }, // Procurador
        { wch: 35 }, // Titular
        { wch: 35 }, // Situação
        { wch: 18 }, // Natureza
        { wch: 18 }, // Apresentação
        { wch: 20 }, // Classes NCL
        { wch: 15 }, // Data Depósito
        { wch: 15 }, // Data Concessão
        { wch: 15 }, // Data Vigência
      ];

      XLSX.utils.book_append_sheet(wb, ws, "Resultados");

      // Generate file name with timestamp
      const now = new Date();
      const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(
        now.getDate()
      ).padStart(2, "0")}_${String(now.getHours()).padStart(2, "0")}${String(
        now.getMinutes()
      ).padStart(2, "0")}`;
      XLSX.writeFile(wb, `busca_marcas_${timestamp}.xlsx`);
    } catch (err) {
      setError("Erro ao exportar: " + (err.message || "Erro desconhecido"));
    } finally {
      setExportLoading(false);
    }
  };

  // ─── Form handlers ───────────────────────────────────────────────────────────

  const handleSearch = (values) => {
    setPage(0);
    setSearchParams(values);
    fetchResults(values, 0, rowsPerPage);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    fetchResults(searchParams, newPage, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchResults(searchParams, 0, newRowsPerPage);
  };

  const handleClear = (resetForm) => {
    resetForm();
    setResults([]);
    setCount(0);
    setPage(0);
    setSearchParams({});
    setError(null);
    setSelectedCFEs([]);
    setCfeExatoOptions({});
  };

  const handleCloseError = () => setError(null);

  // ─── Image similarity ────────────────────────────────────────────────────────

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      setError("Por favor, selecione apenas arquivos de imagem (PNG, JPG, JPEG, GIF).");
      return;
    }
    setUploadedImage(file);
    const reader = new FileReader();
    reader.onload = (e) => setImagePreview(e.target.result);
    reader.readAsDataURL(file);
  };

  const handleImageSimilaritySearch = async () => {
    if (!uploadedImage) {
      setError("Por favor, faça upload de uma imagem para realizar a busca por similaridade.");
      return;
    }
    setImageSimilarityLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append("image", uploadedImage);
      Object.keys(imageSimilarityParams).forEach((key) => {
        if (imageSimilarityParams[key] !== null && imageSimilarityParams[key] !== "")
          formData.append(key, imageSimilarityParams[key]);
      });
      if (selectedCFEs.length > 0) {
        selectedCFEs.forEach((cfe) => formData.append("cfeReferencia", cfe.value));
        selectedCFEs.forEach((cfe) =>
          formData.append("cfeExato", cfeExatoOptions[cfe.value] || false)
        );
      }

      const response = await makeRequest("/webseek/image-similarity", "POST", formData, {
        "Content-Type": "multipart/form-data",
      });

      if (response && (response.status === 200 || response.status === 201)) {
        if (response.data && Array.isArray(response.data.data)) {
          setResults(response.data.data);
          setCount(response.data.pagination?.total || response.data.data.length);
        } else if (response.data && Array.isArray(response.data)) {
          setResults(response.data);
          setCount(response.data.length);
        } else {
          setResults([]);
          setCount(0);
        }
        setImageSimilarityModal(false);
        setPage(0);
      } else {
        setError(
          "Erro na busca por similaridade. Status: " + (response ? response.status : "desconhecido")
        );
      }
    } catch (err) {
      setError("Erro ao realizar busca por similaridade: " + (err.message || "Erro desconhecido"));
    } finally {
      setImageSimilarityLoading(false);
    }
  };

  const handleOpenImageSimilarityModal = () => setImageSimilarityModal(true);

  const handleCloseImageSimilarityModal = () => {
    setImageSimilarityModal(false);
    setUploadedImage(null);
    setImagePreview(null);
    setImageSimilarityParams({
      similarityThreshold: 70,
      incluirMesmaCategoria: true,
      incluirMesmoTitular: false,
      excluirMesmoProcesso: true,
      page: 1,
      limit: 20,
    });
    setSelectedCFEs([]);
    setCfeExatoOptions({});
  };

  // ─── View mode & row selection ───────────────────────────────────────────────

  const handleToggleRow = (index) => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(new Set(results.map((_, i) => i)));
    } else {
      setSelectedRows(new Set());
    }
  };

  // ─── Build row data for copy/export ─────────────────────────────────────────

  const buildRowData = (row, mode) => {
    const marcaNome =
      Array.isArray(row?.marca) && row.marca.length > 0
        ? row.marca[0]?.nome ?? ""
        : row?.marca?.nome ?? "";
    const titulares =
      Array.isArray(row?.titulares) && row.titulares.length > 0
        ? row.titulares.map((t) => t.nome_razao_social).join("; ")
        : "---";
    const classes =
      Array.isArray(row?.classes_nice) && row.classes_nice.length > 0
        ? row.classes_nice.map((c) => c.codigo).join("; ")
        : "---";
    const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("pt-BR") : "---");

    if (mode === "resumido") {
      return [
        row?.numero ?? "---",
        marcaNome || "---",
        row?.apresentacao ?? "---",
        classes,
        titulares,
        fmtDate(row?.data_deposito),
        fmtDate(row?.data_concessao),
        fmtDate(row?.data_vigencia),
      ];
    }
    return [
      row?.numero ?? "---",
      marcaNome || "---",
      row?.apresentacao ?? "---",
      row?.natureza ?? "---",
      classes,
      titulares,
      row?.procurador ?? "---",
      row?.situacao ?? "---",
      fmtDate(row?.data_deposito),
      fmtDate(row?.data_concessao),
      fmtDate(row?.data_vigencia),
    ];
  };

  const getHeaders = (mode) =>
    mode === "resumido"
      ? ["Processo", "Marca", "Apresentação", "Classes NCL", "Titular", "Depósito", "Concessão", "Vigência"]
      : ["Processo", "Marca", "Apresentação", "Natureza", "Classes NCL", "Titular", "Procurador", "Situação", "Depósito", "Concessão", "Vigência"];

  // ─── Copy to clipboard ───────────────────────────────────────────────────────

  const handleCopyToClipboard = () => {
    const targetRows =
      selectedRows.size > 0 ? results.filter((_, i) => selectedRows.has(i)) : results;
    const headers = getHeaders(viewMode);
    const rows = targetRows.map((row) => buildRowData(row, viewMode));
    const text = [headers, ...rows].map((r) => r.join("\t")).join("\n");
    navigator.clipboard.writeText(text).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2500);
    });
  };

  // ─── Export CSV ──────────────────────────────────────────────────────────────

  const handleExportCSV = async () => {
    if (!hasValidSearchParams(searchParams)) {
      setError("Realize uma busca antes de exportar.");
      return;
    }
    setExportLoading(true);
    setError(null);
    try {
      const apiParams = buildApiParams(searchParams, 0, count || 10000);
      const response = await makeRequest("/webseek/search", "POST", apiParams, {});
      let allResults = [];
      if (response?.data?.data && Array.isArray(response.data.data)) {
        allResults = response.data.data;
      } else if (response?.data && Array.isArray(response.data)) {
        allResults = response.data;
      }
      if (allResults.length === 0) {
        setError("Nenhum resultado para exportar.");
        return;
      }
      const headers = getHeaders(viewMode);
      const rows = allResults.map((row) => buildRowData(row, viewMode));
      const csvContent = [headers, ...rows]
        .map((r) => r.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(","))
        .join("\n");
      const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      const now = new Date();
      const ts = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}_${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}`;
      a.href = url;
      a.download = `busca_marcas_${ts}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError("Erro ao exportar CSV: " + (err.message || "Erro desconhecido"));
    } finally {
      setExportLoading(false);
    }
  };

  // ─── CFE data ────────────────────────────────────────────────────────────────

  const getCfeDescription = (cfeCode) => {
    if (!cfeCode) return "Descrição não disponível";
    const exactMatch = cfeCodesList.find((item) => item.value === cfeCode);
    if (exactMatch) return exactMatch.label;
    const partialMatch = cfeCodesList.find(
      (item) => item.value.startsWith(cfeCode) || cfeCode.startsWith(item.value)
    );
    if (partialMatch) return partialMatch.label;
    return `Código ${cfeCode} - Descrição não encontrada`;
  };

  const fetchCfeData = async (processNumber) => {
    if (!processNumber) return;
    setCfeLoading(true);
    setCfeData(null);
    try {
      const response = await makeRequest(`/rpis/cfe/${processNumber}`, "GET");
      if (response && (response.status === 200 || response.status === 201)) {
        if (response.data?.cfe_data) {
          setCfeData({
            classes_vienna: response.data.cfe_data,
            total_classes_vienna: response.data.total_cfe,
          });
        } else {
          setCfeData(null);
        }
      } else {
        setCfeData(null);
      }
    } catch {
      setCfeData(null);
    } finally {
      setCfeLoading(false);
    }
  };

  // ─── NCL classes loader ──────────────────────────────────────────────────────

  useEffect(() => {
    let isMounted = true;
    const loadClasses = async () => {
      if (!isMounted) return;
      setNclClasses(CLASSES_NICE);
      setLoadingNcl(false);
    };
    loadClasses();
    return () => {
      isMounted = false;
    };
  }, []);

  // ─── Safe display helper ─────────────────────────────────────────────────────

  const safe = (v) =>
    v === null || v === undefined || v === "" || (typeof v === "object" && !Array.isArray(v))
      ? "---"
      : v;

  // ─── Render ──────────────────────────────────────────────────────────────────

  return (
    <JumboContentLayout header={<HeaderPages title="Busca" hasButton={false} />}>
      {error && (
        <Alert
          severity="error"
          action={
            <IconButton aria-label="close" color="inherit" size="small" onClick={handleCloseError}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2, maxWidth: "1200px" }}
        >
          {error}
        </Alert>
      )}

      <Formik initialValues={initialValues} onSubmit={handleSearch}>
        {({ values, handleChange, setFieldValue, resetForm }) => (
          <Form>
            <Paper
              variant="outlined"
              sx={{ mb: 2, p: 2, bgcolor: "background.paper", maxWidth: "1200px" }}
            >
              <Grid container spacing={2}>
                {/* ── NCL ── */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                    Classificação NCL:
                  </Typography>
                  {values.nclFields.map((nclField, index) => (
                    <Box key={index} display="flex" alignItems="center" sx={{ mb: 1 }}>
                      <Select
                        value={nclField.value}
                        onChange={(e) => {
                          const newFields = [...values.nclFields];
                          newFields[index].value = e.target.value;
                          setFieldValue("nclFields", newFields);
                        }}
                        size="small"
                        sx={{ mr: 1, minWidth: "200px" }}
                        disabled={loadingNcl}
                        displayEmpty
                      >
                        <MenuItem value="">
                          <em>Nenhum</em>
                        </MenuItem>
                        {nclClasses.map((nclClass) => (
                          <MenuItem key={nclClass.codigo} value={nclClass.codigo}>
                            {nclClass.codigo === "*"
                              ? "Nenhum"
                              : nclClass.especificacao
                              ? `Classe ${nclClass.codigo} - ${
                                  nclClass.especificacao.length > 60
                                    ? nclClass.especificacao.substring(0, 60) + "..."
                                    : nclClass.especificacao
                                }`
                              : `Classe ${nclClass.codigo}`}
                          </MenuItem>
                        ))}
                      </Select>
                      {/* Logic operator shown only when there is a next field or this isn't the first */}
                      {values.nclFields.length > 1 && index < values.nclFields.length - 1 && (
                        <Select
                          value={values.nclFields[index + 1].logic}
                          onChange={(e) => {
                            const newFields = [...values.nclFields];
                            newFields[index + 1].logic = e.target.value;
                            setFieldValue("nclFields", newFields);
                          }}
                          size="small"
                          sx={{ mr: 1, minWidth: "70px" }}
                        >
                          <MenuItem value="ou">ou</MenuItem>
                          <MenuItem value="e">e</MenuItem>
                        </Select>
                      )}
                      {values.nclFields.length > 1 && (
                        <Button
                          size="small"
                          color="error"
                          onClick={() => removeNclField(setFieldValue, values, index)}
                          sx={{ mr: 1 }}
                        >
                          Remover
                        </Button>
                      )}
                      {index === values.nclFields.length - 1 && (
                        <Button
                          size="small"
                          color="primary"
                          onClick={() => addNclField(setFieldValue, values)}
                        >
                          + Adicionar NCL
                        </Button>
                      )}
                    </Box>
                  ))}
                </Grid>

                {/* ── Fonética ── */}
                <Grid item xs={12} md={6}>
                  <FormControl size="small" sx={{ width: "100%", maxWidth: "250px" }}>
                    <InputLabel>Fonética?</InputLabel>
                    <Select
                      name="fonetica"
                      value={values.fonetica}
                      onChange={handleChange}
                      label="Fonética?"
                    >
                      <MenuItem value="Sim">Sim</MenuItem>
                      <MenuItem value="Não">Não</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* ── Palavra ── */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                    Palavra:
                  </Typography>
                  {values.palavraFields.map((palavraField, index) => (
                    <Box key={index} sx={{ mb: 1 }}>
                      <Box display="flex" alignItems="center">
                        <TextField
                          value={palavraField.value}
                          onChange={(e) => {
                            const newFields = [...values.palavraFields];
                            newFields[index].value = e.target.value;
                            setFieldValue("palavraFields", newFields);
                          }}
                          size="small"
                          sx={{ mr: 1, flex: 1 }}
                          placeholder="Digite a palavra"
                        />
                        <Select
                          value={palavraField.option}
                          onChange={(e) => {
                            const newFields = [...values.palavraFields];
                            newFields[index].option = e.target.value;
                            setFieldValue("palavraFields", newFields);
                          }}
                          size="small"
                          sx={{ mr: 1, minWidth: "150px" }}
                        >
                          <MenuItem value="Radical">Radical</MenuItem>
                          <MenuItem value="MarcaExata">Marca Exata</MenuItem>
                          <MenuItem value="ComecaCom">Prefixo</MenuItem>
                          <MenuItem value="TerminaCom">Sufixo</MenuItem>
                          <MenuItem value="Contem">Contém</MenuItem>
                        </Select>
                        {values.palavraFields.length > 1 &&
                          index < values.palavraFields.length - 1 && (
                            <Select
                              value={values.palavraFields[index + 1].logic}
                              onChange={(e) => {
                                const newFields = [...values.palavraFields];
                                newFields[index + 1].logic = e.target.value;
                                setFieldValue("palavraFields", newFields);
                              }}
                              size="small"
                              sx={{ mr: 1, minWidth: "70px" }}
                            >
                              <MenuItem value="ou">ou</MenuItem>
                              <MenuItem value="e">e</MenuItem>
                            </Select>
                          )}
                        {values.palavraFields.length > 1 && (
                          <Button
                            size="small"
                            color="error"
                            onClick={() => removePalavraField(setFieldValue, values, index)}
                            sx={{ mr: 1 }}
                          >
                            Remover
                          </Button>
                        )}
                        {index === values.palavraFields.length - 1 && (
                          <Button
                            size="small"
                            color="primary"
                            onClick={() => addPalavraField(setFieldValue, values)}
                          >
                            + Adicionar Palavra
                          </Button>
                        )}
                      </Box>
                      {["TerminaCom", "Contem"].includes(palavraField.option) && (
                        <Alert severity="warning" sx={{ mt: 0.5, py: 0.5, fontSize: "0.8rem" }}>
                          Esta opção pode ser mais lenta quando a base possui muitos registros, pois a busca precisa verificar muitos dados
                        </Alert>
                      )}
                    </Box>
                  ))}
                </Grid>

                {/* ── Titular (NEW) ── */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                    Titular:
                  </Typography>
                  <TextField
                    name="titular"
                    value={values.titular}
                    onChange={handleChange}
                    size="small"
                    sx={{ minWidth: "400px" }}
                    placeholder="Nome ou razão social do titular"
                  />
                </Grid>

                {/* ── CFE ── */}
                <Grid item xs={12}>
                  <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                    CFE:
                  </Typography>
                  {values.cfeFields.map((cfeField, index) => (
                    <Box key={index} display="flex" alignItems="center" sx={{ mb: 1 }}>
                      <Autocomplete
                        value={
                          cfeCodesList.find((option) => option.value === cfeField.value) || null
                        }
                        onChange={(event, newValue) => {
                          const newFields = [...values.cfeFields];
                          newFields[index].value = newValue ? newValue.value : "";
                          setFieldValue("cfeFields", newFields);
                        }}
                        options={cfeCodesList}
                        getOptionLabel={(option) => option.label}
                        groupBy={(option) => `Categoria ${option.category}`}
                        size="small"
                        sx={{ mr: 1, minWidth: "500px" }}
                        renderInput={(params) => (
                          <TextField {...params} placeholder="Selecione um CFE" size="small" />
                        )}
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={cfeField.exato}
                            onChange={(e) => {
                              const newFields = [...values.cfeFields];
                              newFields[index].exato = e.target.checked;
                              setFieldValue("cfeFields", newFields);
                            }}
                          />
                        }
                        label="Exato"
                        sx={{ mr: 1 }}
                      />
                      {values.cfeFields.length > 1 && index < values.cfeFields.length - 1 && (
                        <Select
                          value={values.cfeFields[index + 1].logic}
                          onChange={(e) => {
                            const newFields = [...values.cfeFields];
                            newFields[index + 1].logic = e.target.value;
                            setFieldValue("cfeFields", newFields);
                          }}
                          size="small"
                          sx={{ mr: 1, minWidth: "70px" }}
                        >
                          <MenuItem value="ou">ou</MenuItem>
                          <MenuItem value="e">e</MenuItem>
                        </Select>
                      )}
                      {values.cfeFields.length > 1 && (
                        <Button
                          size="small"
                          color="error"
                          onClick={() => removeCfeField(setFieldValue, values, index)}
                          sx={{ mr: 1 }}
                        >
                          Remover
                        </Button>
                      )}
                      {index === values.cfeFields.length - 1 && (
                        <Button
                          size="small"
                          color="primary"
                          onClick={() => addCfeField(setFieldValue, values)}
                        >
                          + Adicionar CFE
                        </Button>
                      )}
                    </Box>
                  ))}
                </Grid>

                {/* ── Action bar ── */}
                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography variant="subtitle1" fontWeight="bold" sx={{ mr: 1 }}>
                        Processos:
                      </Typography>
                      <Typography variant="h6" color="primary">
                        {count}
                      </Typography>
                    </Box>
                    <Box display="flex" gap={1}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        size="medium"
                        disabled={loading}
                        startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                      >
                        {loading ? "PESQUISANDO..." : "PESQUISAR"}
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="medium"
                        disabled={loading}
                        startIcon={<ImageIcon />}
                        onClick={handleOpenImageSimilarityModal}
                      >
                        BUSCA POR IMAGEM
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => handleClear(resetForm)}
                        size="medium"
                        disabled={loading}
                      >
                        LIMPAR
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Form>
        )}
      </Formik>

      {/* ── Loading ── */}
      {loading && (
        <Box width="100%" display="flex" justifyContent="center" my={4}>
          <CircularProgress />
        </Box>
      )}

      {/* ── Results table ── */}
      {!loading && (
        <>
          {results.length === 0 ? (
            <Paper variant="outlined" sx={{ p: 3, mb: 2, textAlign: "center" }}>
              <Typography variant="body1" color="textSecondary">
                {hasValidSearchParams(searchParams)
                  ? "Nenhum resultado encontrado para sua pesquisa."
                  : "Utilize o formulário acima para realizar uma pesquisa."}
              </Typography>
            </Paper>
          ) : (
            <TableContainer component={Paper} sx={{ mb: 2 }}>
              {/* ── Toolbar ── */}
              <Box
                sx={{
                  px: 2,
                  py: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 1,
                  borderBottom: "1px solid",
                  borderColor: "divider",
                }}
              >
                {/* View mode toggle */}
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="body2" color="text.secondary" sx={{ mr: 0.5 }}>
                    Visualização:
                  </Typography>
                  <ToggleButtonGroup
                    value={viewMode}
                    exclusive
                    onChange={(_, v) => v && setViewMode(v)}
                    size="small"
                  >
                    <ToggleButton value="resumido" sx={{ px: 2, gap: 0.5 }}>
                      <ViewListIcon fontSize="small" />
                      Resumido
                    </ToggleButton>
                    <ToggleButton value="detalhado" sx={{ px: 2, gap: 0.5 }}>
                      <TableRowsIcon fontSize="small" />
                      Detalhado
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Box>

                {/* Action buttons */}
                <Box display="flex" gap={1} flexWrap="wrap">
                  <Tooltip
                    title={
                      selectedRows.size > 0
                        ? `Copiar ${selectedRows.size} linha(s) selecionada(s)`
                        : "Copiar todos os resultados"
                    }
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<ContentCopyIcon />}
                      onClick={handleCopyToClipboard}
                    >
                      {selectedRows.size > 0 ? `Copiar (${selectedRows.size})` : "Copiar Tudo"}
                    </Button>
                  </Tooltip>
                  <Button
                    variant="outlined"
                    color="success"
                    size="small"
                    disabled={exportLoading}
                    startIcon={exportLoading ? <CircularProgress size={16} /> : <DownloadIcon />}
                    onClick={(e) => setExportMenuAnchor(e.currentTarget)}
                  >
                    Exportar
                  </Button>
                  <Menu
                    anchorEl={exportMenuAnchor}
                    open={Boolean(exportMenuAnchor)}
                    onClose={() => setExportMenuAnchor(null)}
                  >
                    <MenuItem
                      onClick={() => {
                        setExportMenuAnchor(null);
                        handleExportExcel();
                      }}
                    >
                      Excel (.xlsx)
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setExportMenuAnchor(null);
                        handleExportCSV();
                      }}
                    >
                      CSV (.csv)
                    </MenuItem>
                  </Menu>
                </Box>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        size="small"
                        checked={selectedRows.size === results.length && results.length > 0}
                        indeterminate={selectedRows.size > 0 && selectedRows.size < results.length}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell sx={{ minWidth: 70 }}>Figura</TableCell>
                    <TableCell sx={{ minWidth: 120 }}>Nº Processo</TableCell>
                    <TableCell sx={{ minWidth: 160 }}>Marca</TableCell>
                    <TableCell sx={{ minWidth: 110 }}>Apresentação</TableCell>
                    <TableCell sx={{ minWidth: 100 }}>Classes NCL</TableCell>
                    <TableCell sx={{ minWidth: 160 }}>Titular</TableCell>
                    {viewMode === "detalhado" && (
                      <>
                        <TableCell sx={{ minWidth: 100 }}>Natureza</TableCell>
                        <TableCell sx={{ minWidth: 140 }}>Procurador</TableCell>
                        <TableCell sx={{ minWidth: 160 }}>Situação</TableCell>
                      </>
                    )}
                    <TableCell sx={{ minWidth: 100 }}>Depósito</TableCell>
                    <TableCell sx={{ minWidth: 100 }}>Concessão</TableCell>
                    <TableCell sx={{ minWidth: 100 }}>Vigência</TableCell>
                    {results.some((row) => row.similarityScore !== undefined) && (
                      <>
                        <TableCell>Similaridade</TableCell>
                        <TableCell>Fatores</TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(results) &&
                    results
                      .filter((row) => !!row && typeof row === "object")
                      .map((row, index) => {
                        const marcaNome =
                          Array.isArray(row?.marca) && row.marca.length > 0
                            ? row.marca[0]?.nome ?? ""
                            : row?.marca?.nome ?? "";
                        const titulares =
                          Array.isArray(row?.titulares) && row.titulares.length > 0
                            ? row.titulares.map((t) => t.nome_razao_social).join("; ")
                            : "---";
                        const classes =
                          Array.isArray(row?.classes_nice) && row.classes_nice.length > 0
                            ? row.classes_nice.map((c) => c.codigo).join("; ")
                            : "---";
                        const fmtDate = (d) =>
                          d ? new Date(d).toLocaleDateString("pt-BR") : "---";

                        return (
                          <TableRow
                            key={index}
                            hover
                            selected={selectedRows.has(index)}
                            sx={{ verticalAlign: "middle" }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                size="small"
                                checked={selectedRows.has(index)}
                                onChange={() => handleToggleRow(index)}
                              />
                            </TableCell>
                            <TableCell>
                              <img
                                src={
                                  row.imagem_marca
                                    ? `${
                                        process.env.REACT_APP_BACKEND_URL || ""
                                      }/public/images/marcas/${row.imagem_marca}`
                                    : "https://via.placeholder.com/60x40?text=Sem+Imagem"
                                }
                                alt={marcaNome}
                                style={{
                                  maxWidth: 60,
                                  maxHeight: 40,
                                  objectFit: "contain",
                                  border: "1px solid #eee",
                                  borderRadius: 4,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setSelectedImageProcesso(row);
                                  setImageViewModalOpen(true);
                                  fetchCfeData(row.numero);
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "https://via.placeholder.com/60x40?text=Sem+Imagem";
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <span
                                style={{
                                  color: "#16355D",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontWeight: 600,
                                  fontSize: 14,
                                  display: "inline-flex",
                                  alignItems: "center",
                                }}
                                onClick={() => {
                                  setSelectedProcesso(row);
                                  setDetailModalOpen(true);
                                }}
                              >
                                <span style={{ marginRight: 4 }}>{safe(row?.numero)}</span>
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#16355D"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  style={{ marginLeft: 2 }}
                                >
                                  <circle cx="12" cy="12" r="10" />
                                  <circle cx="12" cy="12" r="3" />
                                  <path d="M22 12c-2-4-6-7-10-7S4 8 2 12c2 4 6 7 10 7s8-3 10-7z" />
                                </svg>
                              </span>
                            </TableCell>
                            <TableCell>{safe(marcaNome)}</TableCell>
                            <TableCell>
                              <Typography
                                variant="caption"
                                sx={{
                                  px: 0.8,
                                  py: 0.3,
                                  borderRadius: 1,
                                  fontWeight: 600,
                                  bgcolor:
                                    row?.apresentacao === "Mista"
                                      ? "info.50"
                                      : row?.apresentacao === "Nominativa"
                                      ? "success.50"
                                      : "grey.100",
                                  color:
                                    row?.apresentacao === "Mista"
                                      ? "info.dark"
                                      : row?.apresentacao === "Nominativa"
                                      ? "success.dark"
                                      : "text.secondary",
                                  border: "1px solid",
                                  borderColor:
                                    row?.apresentacao === "Mista"
                                      ? "info.200"
                                      : row?.apresentacao === "Nominativa"
                                      ? "success.200"
                                      : "grey.300",
                                  display: "inline-block",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {row?.apresentacao
                                  ? row.apresentacao === "Mista"
                                    ? "M – Mista"
                                    : row.apresentacao === "Nominativa"
                                    ? "N – Nominativa"
                                    : row.apresentacao
                                  : "---"}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ fontSize: 13 }}>
                                {classes}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2" sx={{ fontSize: 13 }}>
                                {titulares}
                              </Typography>
                            </TableCell>
                            {viewMode === "detalhado" && (
                              <>
                                <TableCell>{safe(row?.natureza)}</TableCell>
                                <TableCell>{safe(row?.procurador)}</TableCell>
                                <TableCell>{safe(row?.situacao)}</TableCell>
                              </>
                            )}
                            <TableCell>{fmtDate(row?.data_deposito)}</TableCell>
                            <TableCell>{fmtDate(row?.data_concessao)}</TableCell>
                            <TableCell>{fmtDate(row?.data_vigencia)}</TableCell>
                            {row.similarityScore !== undefined && (
                              <>
                                <TableCell>
                                  <Typography
                                    variant="body2"
                                    color={
                                      row.similarityScore >= 80
                                        ? "success.main"
                                        : row.similarityScore >= 60
                                        ? "warning.main"
                                        : "text.secondary"
                                    }
                                    fontWeight="bold"
                                  >
                                    {row.similarityScore.toFixed(1)}%
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  {row.similarityFactors && (
                                    <Box>
                                      {row.similarityFactors.cfe && (
                                        <Typography variant="caption" display="block">
                                          CFE: {row.similarityFactors.cfe.score.toFixed(1)}%
                                        </Typography>
                                      )}
                                      {row.similarityFactors.titular && (
                                        <Typography variant="caption" display="block">
                                          Titular:{" "}
                                          {row.similarityFactors.titular.score.toFixed(1)}%
                                        </Typography>
                                      )}
                                      {row.similarityFactors.classes && (
                                        <Typography variant="caption" display="block">
                                          Classes:{" "}
                                          {row.similarityFactors.classes.score.toFixed(1)}%
                                        </Typography>
                                      )}
                                    </Box>
                                  )}
                                </TableCell>
                              </>
                            )}
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={count}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={[10, 30, 50, 100]}
              />
            </TableContainer>
          )}
        </>
      )}

      {/* ── Copy success snackbar ── */}
      <Snackbar
        open={copySuccess}
        autoHideDuration={2500}
        onClose={() => setCopySuccess(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message="Resultado copiado para a área de transferência!"
      />

      <Dialog
        open={imageSimilarityModal}
        onClose={handleCloseImageSimilarityModal}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" component="span">
              Busca por Similaridade de Imagem
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleCloseImageSimilarityModal}
              sx={{ color: "grey.500" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ px: 4, py: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                Upload de Imagem
              </Typography>
              <Box
                sx={{
                  border: "2px dashed #ccc",
                  borderRadius: 2,
                  p: 3,
                  textAlign: "center",
                  bgcolor: "grey.50",
                  cursor: "pointer",
                  "&:hover": { bgcolor: "grey.100" },
                }}
                component="label"
              >
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: "none" }}
                />
                {imagePreview ? (
                  <Box>
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{ maxWidth: "100%", maxHeight: "200px", objectFit: "contain" }}
                    />
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Clique para trocar a imagem
                    </Typography>
                  </Box>
                ) : (
                  <Box>
                    <CloudUploadIcon sx={{ fontSize: 48, color: "grey.400", mb: 1 }} />
                    <Typography variant="body1" gutterBottom>
                      Clique ou arraste uma imagem aqui
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      Formatos suportados: PNG, JPG, JPEG, GIF
                    </Typography>
                  </Box>
                )}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                CFE de Referência (Opcional)
              </Typography>
              <Autocomplete
                multiple
                size="small"
                options={cfeCodesList}
                value={selectedCFEs}
                onChange={handleCFESelection}
                getOptionLabel={(option) => option.label}
                groupBy={(option) => `Categoria ${option.category}`}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Selecione CFEs de referência" size="small" />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      key={option.value}
                      variant="outlined"
                      label={option.value}
                      size="small"
                      {...getTagProps({ index })}
                    />
                  ))
                }
                sx={{ mb: 1 }}
              />
              {selectedCFEs.length > 0 && (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                  {selectedCFEs.map((cfe) => (
                    <FormControlLabel
                      key={cfe.value}
                      control={
                        <Checkbox
                          size="small"
                          checked={cfeExatoOptions[cfe.value] || false}
                          onChange={(e) => handleCFEExatoChange(cfe.value, e.target.checked)}
                        />
                      }
                      label={`${cfe.value} Exato`}
                    />
                  ))}
                </Box>
              )}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                Parâmetros de Similaridade
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography gutterBottom>
                Limiar de Similaridade: {imageSimilarityParams.similarityThreshold}%
              </Typography>
              <Slider
                value={imageSimilarityParams.similarityThreshold}
                onChange={(e, value) =>
                  setImageSimilarityParams({ ...imageSimilarityParams, similarityThreshold: value })
                }
                min={40}
                max={95}
                step={5}
                marks={[
                  { value: 40, label: "40%" },
                  { value: 70, label: "70%" },
                  { value: 95, label: "95%" },
                ]}
                valueLabelDisplay="auto"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                type="number"
                label="Limite de Resultados"
                value={imageSimilarityParams.limit}
                onChange={(e) =>
                  setImageSimilarityParams({
                    ...imageSimilarityParams,
                    limit: parseInt(e.target.value) || 20,
                  })
                }
                inputProps={{ min: 5, max: 100 }}
              />
            </Grid>
            <Grid item xs={12}>
              <FormLabel component="legend">Opções de Filtro</FormLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={imageSimilarityParams.incluirMesmaCategoria}
                      onChange={(e) =>
                        setImageSimilarityParams({
                          ...imageSimilarityParams,
                          incluirMesmaCategoria: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Incluir mesma categoria"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={imageSimilarityParams.incluirMesmoTitular}
                      onChange={(e) =>
                        setImageSimilarityParams({
                          ...imageSimilarityParams,
                          incluirMesmoTitular: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Incluir mesmo titular"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={imageSimilarityParams.excluirMesmoProcesso}
                      onChange={(e) =>
                        setImageSimilarityParams({
                          ...imageSimilarityParams,
                          excluirMesmoProcesso: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Excluir mesmo processo"
                />
              </FormGroup>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImageSimilarityModal} disabled={imageSimilarityLoading}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleImageSimilaritySearch}
            disabled={imageSimilarityLoading}
            startIcon={imageSimilarityLoading ? <CircularProgress size={20} /> : <SearchIcon />}
          >
            {imageSimilarityLoading ? "Buscando..." : "Buscar Similaridade"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Image View Modal ── */}
      <Dialog
        open={imageViewModalOpen}
        onClose={() => {
          setImageViewModalOpen(false);
          setCfeData(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" component="span">
              Imagem da Marca e Dados CFE
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => {
                setImageViewModalOpen(false);
                setCfeData(null);
              }}
              sx={{ color: "grey.500" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent dividers sx={{ px: 4, py: 3 }}>
          {selectedImageProcesso && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom>
                  Imagem da Marca
                </Typography>
                <Box sx={{ textAlign: "center", mb: 2 }}>
                  <img
                    src={
                      selectedImageProcesso.imagem_marca
                        ? `${process.env.REACT_APP_BACKEND_URL || ""}/public/images/marcas/${
                            selectedImageProcesso.imagem_marca
                          }`
                        : "https://via.placeholder.com/300x200?text=Sem+Imagem"
                    }
                    alt={selectedImageProcesso.numero}
                    style={{
                      maxWidth: "100%",
                      maxHeight: "400px",
                      objectFit: "contain",
                      border: "2px solid #eee",
                      borderRadius: 8,
                      backgroundColor: "#fff",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://via.placeholder.com/300x200?text=Imagem+Não+Encontrada";
                    }}
                  />
                </Box>
                <Typography variant="body2" color="textSecondary" sx={{ textAlign: "center" }}>
                  <strong>Processo:</strong> {selectedImageProcesso.numero}
                  <br />
                  <strong>Marca:</strong>{" "}
                  {Array.isArray(selectedImageProcesso.marca) &&
                  selectedImageProcesso.marca.length > 0
                    ? selectedImageProcesso.marca[0].nome
                    : selectedImageProcesso.marca?.nome || "---"}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom>
                  Dados CFE (Classificação de Viena)
                </Typography>
                {cfeLoading ? (
                  <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                    <CircularProgress />
                  </Box>
                ) : cfeData?.classes_vienna?.length > 0 ? (
                  <Box>
                    <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
                      Total de classes encontradas:{" "}
                      {cfeData.total_classes_vienna || cfeData.classes_vienna.length}
                    </Typography>
                    {cfeData.classes_vienna.map((cfe, index) => {
                      const cfeCode = cfe.codigo || cfe.cfe || cfe.code || "";
                      return (
                        <Paper key={index} sx={{ p: 2, mb: 2, backgroundColor: "#f8f9fa" }}>
                          <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
                            <Box sx={{ minWidth: "80px" }}>
                              <Typography variant="subtitle2" fontWeight="bold" color="primary">
                                {cfeCode || "---"}
                              </Typography>
                            </Box>
                            <Box sx={{ flex: 1 }}>
                              <Typography variant="body2">{getCfeDescription(cfeCode)}</Typography>
                            </Box>
                          </Box>
                        </Paper>
                      );
                    })}
                  </Box>
                ) : (
                  <Paper sx={{ p: 3, textAlign: "center", backgroundColor: "#f5f5f5" }}>
                    <Typography variant="body1" color="textSecondary">
                      {cfeData === null
                        ? "Nenhuma classificação CFE encontrada para este processo."
                        : "Nenhuma classificação CFE encontrada para este processo."}
                    </Typography>
                  </Paper>
                )}
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>

      {/* ── Detail Modal ── */}
      <Dialog
        open={detailModalOpen}
        onClose={() => {
          setDetailModalOpen(false);
          setSelectedProcesso(null);
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          Detalhes do Processo
          <IconButton
            aria-label="close"
            onClick={() => {
              setDetailModalOpen(false);
              setSelectedProcesso(null);
            }}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ px: 4, py: 3 }}>
          {selectedProcesso && (
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <img
                    src={
                      selectedProcesso.imagem_marca
                        ? `${process.env.REACT_APP_BACKEND_URL || ""}/public/images/marcas/${
                            selectedProcesso.imagem_marca
                          }`
                        : "https://via.placeholder.com/200x200?text=Sem+Imagem"
                    }
                    alt={selectedProcesso.numero}
                    style={{
                      maxWidth: "100%",
                      maxHeight: 200,
                      objectFit: "contain",
                      border: "1px solid #eee",
                      borderRadius: 4,
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "https://via.placeholder.com/200x200?text=Sem+Imagem";
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <Typography variant="subtitle2">
                    <b>ID:</b> {selectedProcesso.id}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Nº Processo:</b> {selectedProcesso.numero}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Procurador:</b> {selectedProcesso.procurador || "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Titular:</b>{" "}
                    {Array.isArray(selectedProcesso.titulares) &&
                    selectedProcesso.titulares.length > 0
                      ? selectedProcesso.titulares.map((t) => t.nome_razao_social).join(", ")
                      : "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Data Depósito:</b>{" "}
                    {selectedProcesso.data_deposito
                      ? new Date(selectedProcesso.data_deposito).toLocaleDateString()
                      : "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Data Concessão:</b>{" "}
                    {selectedProcesso.data_concessao
                      ? new Date(selectedProcesso.data_concessao).toLocaleDateString()
                      : "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Data Vigência:</b>{" "}
                    {selectedProcesso.data_vigencia
                      ? new Date(selectedProcesso.data_vigencia).toLocaleDateString()
                      : "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Apostila:</b> {selectedProcesso.apostila || "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Natureza:</b> {selectedProcesso.natureza || "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Apresentação:</b> {selectedProcesso.apresentacao || "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Situação:</b> {selectedProcesso.situacao || "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Acompanhado pela Bunker:</b>{" "}
                    {selectedProcesso.is_acompanhado_pela_bunker ? "Sim" : "Não"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Processo de Terceiro:</b>{" "}
                    {selectedProcesso.is_processo_de_terceiro ? "Sim" : "Não"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Revista RPI:</b>{" "}
                    {selectedProcesso.revista_rpi
                      ? `${selectedProcesso.revista_rpi.numero} (${
                          selectedProcesso.revista_rpi.data_lancamento
                            ? new Date(
                                selectedProcesso.revista_rpi.data_lancamento
                              ).toLocaleDateString()
                            : ""
                        })`
                      : "---"}
                  </Typography>
                  <Typography variant="subtitle2">
                    <b>Marca:</b>{" "}
                    {Array.isArray(selectedProcesso.marca) && selectedProcesso.marca.length > 0
                      ? selectedProcesso.marca[0].nome
                      : "---"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
        <Box mt={4} mb={2} display="flex" justifyContent="center" px={3}>
          <Button
            variant="outlined"
            color="primary"
            size="large"
            sx={{
              width: "100%",
              maxWidth: 400,
              fontWeight: 600,
              fontSize: 18,
              backgroundColor: "#fff",
              border: "2px solid #16355D",
              color: "#16355D",
              "&:hover": { backgroundColor: "#f5faff", border: "2px solid #16355D" },
            }}
            onClick={() => {
              if (selectedProcesso?.id) navigateToProcesso(selectedProcesso.id);
            }}
          >
            Ver mais detalhes do processo
          </Button>
        </Box>
      </Dialog>
    </JumboContentLayout>
  );
}

export default WebseekPage;
